import React from 'react';
import EventIcon from '@mui/icons-material//CalendarToday';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { MaterialUiPickersDate } from '@mui/x-date-pickers/typings/date';
import { ENTER_DATE } from 'common/constants/process-management';
import theme from 'theme';
import { dbShortDate } from 'utilities';
import { ProcessManagementQuestionsFormDateInputProps } from './types';

const CustomTextFieldComponent = React.memo((props: TextFieldProps) => (
  <TextField
    {...props}
    variant="outlined"
    InputProps={{
      style: {
        color: `${theme.palette.primary[700]}`,
        fontWeight: 400,
        fontSize: '1rem',
        border: 'none',
      },
      startAdornment: (
        <InputAdornment position="start">
          <EventIcon style={{ color: theme.palette.primary[700] }} />
        </InputAdornment>
      ),
    }}
    InputLabelProps={{
      style: {
        color: `${theme.palette.primary[700]}`,
        fontWeight: 400,
        fontSize: '1rem',
      },
    }}
    placeholder={ENTER_DATE}
  />
));

const ProcessManagementQuestionsFormDateInput = ({
  answerToDisplay,
  handleAnswerQuestion,
}: ProcessManagementQuestionsFormDateInputProps) => {
  const handleChangeDate = (date: MaterialUiPickersDate) => {
    if (date) {
      handleAnswerQuestion(dbShortDate(date) ?? '');
    }
  };

  return (
    <DatePicker
      style={{
        borderRadius: '8px',
        border: `1px solid ${theme.palette.primary[700]}`,
        color: `${theme.palette.primary[700]}`,
      }}
      format="MM/dd/yyyy"
      value={answerToDisplay === '' ? null : answerToDisplay}
      onChange={handleChangeDate}
      inputVariant="outlined"
      fullWidth
      placeholder={ENTER_DATE}
      TextFieldComponent={CustomTextFieldComponent}
    />
  );
};

export default ProcessManagementQuestionsFormDateInput;
